import cn from 'classnames';
import { Form } from 'connex-cds';
import React from 'react';
import { useNavigate } from 'react-router';
import { Route, Routes, useParams } from 'react-router-dom';
import styled from 'styled-components';
import config from './config';
import { useNotification } from './notification/useNotification';
import style from './style';
import { Success } from './Success';
import ToastContainer from './notification/Toast/ToastContainer';
import { useRegister } from './useRegister';
import { View } from './View';

const Styled = styled.div`
  ${style}
`;

export const RegisterRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Register />} />
      <Route path="success" element={<Success />} />
    </Routes>
  );
};

export const Register = () => {
  const { busy, register } = useRegister();
  const params = useParams();
  const navigate = useNavigate();

  const handleSubmit = React.useCallback(
    profile => {
      return register({ profile, eula: 'accepted', terms: 'accepted' }).then(() => {
        navigate('success');
      });
    },
    [navigate, register]
  );

  const initialValues = React.useMemo(() => {
    const [code, username] = params?.data
      ? atob(params?.data)?.split?.('::') || [undefined, undefined]
      : [undefined, undefined];

    return {
      code: code || '',
      username: username || '',
      lastName: '',
      firstName: '',
      phone: '',
      password: '',
      passwordVerify: '',
    };
  }, [params?.data]);

  useNotification();

  return (
    <Styled className={cn('register')}>
      <ToastContainer duration={2000} />
      <Form.FormProvider config={config} onSubmit={handleSubmit} initialValues={initialValues}>
        <View busy={busy} />
      </Form.FormProvider>
    </Styled>
  );
};
